var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 85 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-details",
    points: "0 0 88.5825 0 88.5825 88.582 0 88.582"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESIGN-SYSTEM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-136.000000, -372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_account",
    transform: "translate(136.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 85,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9697,39.6677 C32.9697,33.4247 38.0487,28.3457 44.2917,28.3457 C50.5337,28.3457 55.6127,33.4247 55.6127,39.6677 C55.6127,45.9107 50.5337,50.9897 44.2917,50.9897 C38.0487,50.9897 32.9697,45.9107 32.9697,39.6677 M52.2037,52.2297 C56.3737,49.5937 59.1567,44.9547 59.1567,39.6677 C59.1567,31.4707 52.4877,24.8027 44.2917,24.8027 C36.0947,24.8027 29.4267,31.4707 29.4267,39.6677 C29.4267,44.9547 32.2097,49.5937 36.3787,52.2297 C25.7307,55.5957 17.9897,65.5657 17.9897,77.3127 L17.9897,78.2557 L21.5327,78.2557 L21.5327,77.3127 C21.5327,64.7637 31.7417,54.5537 44.2917,54.5537 C56.8407,54.5537 67.0507,64.7637 67.0507,77.3127 L67.0507,78.2557 L70.5937,78.2557 L70.5937,77.3127 C70.5937,65.5657 62.8517,55.5957 52.2037,52.2297",
    id: "Fill-1",
    fill: "#74DDBC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-details",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-details"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2915,3.543 C21.8225,3.543 3.5435,21.822 3.5435,44.291 C3.5435,66.76 21.8225,85.039 44.2915,85.039 C66.7605,85.039 85.0395,66.76 85.0395,44.291 C85.0395,21.822 66.7605,3.543 44.2915,3.543 M44.2915,88.582 C19.8695,88.582 -0.0005,68.713 -0.0005,44.291 C-0.0005,19.869 19.8695,0 44.2915,0 C68.7135,0 88.5825,19.869 88.5825,44.291 C88.5825,68.713 68.7135,88.582 44.2915,88.582",
    id: "Fill-3",
    fill: "#1B3D6E",
    mask: "url(#mask-details)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetails);
export default __webpack_public_path__ + "static/media/icon_details.2d9eb517.svg";
export { ForwardRef as ReactComponent };